import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/proxy/authorization', request)
}

export {get}
